/** Need this since setSelectedNodeType happens onPaneClick as well */
import { useEffect } from "react";
import { TEMP } from "@zapier/canvas-constants";
import { useAtomValue, useSetAtom } from "jotai";
import { nodesAtom, selectedNodeTypeAtom } from "@zapier/canvas-state";

/** setSelectedNodeType happens onPaneClick as well as DnD toolbar */
const useRemoveTempNodesAndEdges = () => {
  const selectedNodeType = useAtomValue(selectedNodeTypeAtom);
  const setNodes = useSetAtom(nodesAtom);

  useEffect(() => {
    if (selectedNodeType === null) {
      /** Remove temp nodes */
      setNodes((ns) => ns.filter((n) => n.id !== TEMP));
    }
  }, [setNodes, selectedNodeType]);
};

export default useRemoveTempNodesAndEdges;
